import React, { Component } from 'react';
import './Form.css';
import SelectField from './SelectField';
import TextField from './TextField';
import TextAreaField from './TextAreaField';
import CaptchaField from './CaptchaField';
import ActionButton from '../ActionButton';
import langFieldOptions from './langFieldOptions';
import selectFieldsConfiguration from './selectFieldsConfiguration';
import formsConfiguration from './formsConfiguration';
import i18n from '../../i18n';
import { queryParameters } from '../../queryParameters';
import filterSelectFields from './filterSelectFields';
import { isDisabled } from '../../utils/isDisabled';
import { isHidden } from '../../utils/isHidden';

class Form extends Component {
    constructor(props, context) {
        super(props, context);
        this.formType = props.formType;
        this.issueTypes = filterSelectFields.filterSelectOptions(this.formType, 'issueTypes');
        this.issueSubTypes = filterSelectFields.filterSelectNestedOptions(this.formType, 'issueSubTypes');
        this.games = filterSelectFields.filterSelectOptions(this.formType, 'games');
        this.source = this.getSource(this.formType);
        this.soportoFormType = this.getSoportoFormType(this.formType);
    }

    getSource(formType) {
        return formsConfiguration.form[formType].source;
    }

    getSoportoFormType(formType) {
        return formsConfiguration.form[formType].soportoFormType;
    }

    getSessionKey() {
        return queryParameters.get('sessionKey');
    }

    componentDidMount() {
        this.props.onSessionKeyUpdate(this.getSessionKey());
        this.props.onSourceUpdate(this.source);
        this.props.onSoportoFormTypeUpdate(this.soportoFormType);

        const { predefinedFields } = formsConfiguration.form[this.formType];
        if (!predefinedFields) {
            return;
        }

        const newFormData = {};
        Object.keys(predefinedFields).forEach((key) => {
            newFormData[key] = { value: predefinedFields[key], isValid: true };
        });
        this.props.forceFormDataUpdate(newFormData);
    }

    render() {
        const isValidationEnabled = this.props.isValidationEnabled;
        const onFieldUpdate = this.props.onFieldUpdate;
        const onFieldHide = this.props.onFieldHide;
        const formData = this.props.formData;
        const formType = formsConfiguration.form[this.formType];
        const getCopy = (i18nKey) => i18n.getCopy(this.props.lang, i18nKey);
        const getMessageLabel = () => {
            if (formData.issueSubType && formData.issueSubType.value === 'gifting_card') {
                return getCopy('field.label.message_include_gift_card_number');
            }
            if (formData.issueSubType && (
                    ['community_appeal_moderation', 'appeal_account_decision'].includes(formData.issueSubType.value))) {
                return getCopy('field.label.message_community_appeal_moderation');
            }
            if (formData.issueType && formData.issueType.value === 'community_report_abuse') {
                return getCopy('field.label.message_community_report_abuse');
            }
            return getCopy('field.label.message');
        };

        return (
            <div className="Form">
                <h1 className={`Form-title`}>{getCopy('form.title')}</h1>
                <form className={`Form-content`} lang={i18n.normalizeLang(this.props.lang)}>
                    <SelectField
                        fieldConfig={{
                            id: 'lang',
                            label: getCopy('field.label.lang'),
                            validations: {
                                required: true
                            },
                            options: langFieldOptions
                        }}
                        value={this.props.lang}
                        onFieldUpdate={this.props.onLanguageChange}
                        showValidationError={false}
                    />
                    <TextField
                        fieldConfig={{
                            id: 'email',
                            label: getCopy('field.label.email'),
                            errorMsg: getCopy('field.error.email'),
                            placeholder: getCopy('field.placeholder.email'),
                            type: 'email',
                            validations: {
                                required: true,
                                email: true
                            }
                        }}
                        value={formData.email.value}
                        onFieldUpdate={onFieldUpdate}
                        showValidationError={isValidationEnabled && !formData.email.isValid}
                    />
                    <TextField
                        fieldConfig={{
                            id: 'name',
                            label: getCopy('field.label.name'),
                            errorMsg: getCopy('field.error.name'),
                            type: 'text',
                            validations: {
                                required: true
                            }
                        }}
                        value={formData.name.value}
                        onFieldUpdate={onFieldUpdate}
                        showValidationError={isValidationEnabled && !formData.name.isValid}
                    />
                    <SelectField
                        fieldConfig={{
                            id: 'game',
                            label: getCopy('field.label.game'),
                            errorMsg: getCopy('field.error.game'),
                            validations: {
                                required: true
                            },
                            options: this.games
                        }}
                        value={formData.game.value}
                        onFieldUpdate={(id, value, fieldConfig) => {
                            onFieldUpdate(id, value, fieldConfig, 'platform');
                        }}
                        showValidationError={isValidationEnabled && !formData.game.isValid}
                        hide={isHidden('game', formType)}
                        onFieldHide={onFieldHide}
                        disabled={isDisabled('game', formType)}
                    />
                    {formData.game.value && (
                        <SelectField
                            fieldConfig={{
                                id: 'platform',
                                label: getCopy('field.label.platform'),
                                errorMsg: getCopy('field.error.platform'),
                                validations: {
                                    required: true
                                },
                                options: selectFieldsConfiguration.platforms[formData.game.value] || []
                            }}
                            value={formData.platform.value}
                            onFieldUpdate={onFieldUpdate}
                            hide={isHidden('platform', formType)}
                            onFieldHide={onFieldHide}
                            showValidationError={isValidationEnabled && !formData.platform.isValid}
                        />
                    )}
                    <SelectField
                        fieldConfig={{
                            id: 'issueType',
                            label: getCopy('field.label.type'),
                            errorMsg: getCopy('field.error.type'),
                            validations: {
                                required: true
                            },
                            options: this.issueTypes
                        }}
                        value={formData.issueType.value}
                        onFieldUpdate={(id, value, fieldConfig) => {
                            onFieldUpdate(id, value, fieldConfig, 'issueSubType');
                        }}
                        showValidationError={isValidationEnabled && !formData.issueType.isValid}
                        getCopy={getCopy}
                        hide={isHidden('issueType', formType)}
                        disabled={isDisabled('issueType', formType)}
                        onFieldHide={onFieldHide}
                    />

                    {formData.issueType.value && (
                        <SelectField
                            fieldConfig={{
                                id: 'issueSubType',
                                label: getCopy('field.label.subType'),
                                errorMsg: getCopy('field.error.subType'),
                                validations: {
                                    required: true
                                },
                                options: this.issueSubTypes[formData.issueType.value] || []
                            }}
                            value={formData.issueSubType.value}
                            onFieldUpdate={onFieldUpdate}
                            showValidationError={isValidationEnabled && !formData.issueSubType.isValid}
                            getCopy={getCopy}
                            disabled={isDisabled('issueSubType', formType)}
                            hide={isHidden('issueSubType', formType)}
                            onFieldHide={onFieldHide}
                        />
                    )}
                    <TextAreaField
                        fieldConfig={{
                            id: 'message',
                            label: getMessageLabel(),
                            errorMsg: getCopy('field.error.message'),
                            errorMinMsg: getCopy('field.error.min_message'),
                            charsLeftMsg: getCopy('field.message.char.counter'),
                            placeholder: getCopy('field.placeholder.message')
                        }}
                        value={formData.message.value}
                        hide={isHidden('message', formType)}
                        onFieldUpdate={this.props.onMsgUpdate}
                        showValidationError={isValidationEnabled && !formData.message.isValid}
                    />
                    <CaptchaField
                        fieldConfig={{
                            label: getCopy('field.label.captcha'),
                            errorMsg: getCopy('field.error.captcha')
                        }}
                        showValidationError={isValidationEnabled && !this.props.captchaToken}
                    />
                    <ActionButton buttonMsg={getCopy('button.submit')} onClickButton={this.props.onSubmitClick} />
                    {isValidationEnabled && (
                        <p className="Form-validation-error">{getCopy('validation.error.message')}</p>
                    )}
                </form>
            </div>
        );
    }
}

export default Form;



// WEBPACK FOOTER //
// ./src/components/Form/Form.js